import { fetchPatchApplicationsAccountFileFeedback } from '@iwoca/lapi-client/edge';
import { fork, put, take, takeLatest } from 'redux-saga/effects';

import { OPEN_ERROR_MODAL } from '../../iwModals/Modals.actions';
import {
    API_GET_IWOCAPAY_CAPTURED_PAYMENTS,
    API_GET_IWOCAPAY_PAY_LINKS
} from '../../myAccount/iwocaPay/api/LendingAPI.actions';
import { forkLatestAPI, putAndWaitAPI, selectAPI } from '../API.sagas';
import {
    isTimeoutSessionResponse,
    validateCustomerState
} from './CustomerStateAPIHelper';
import * as lendingApi from './LendingAPI';
import * as apiActions from './LendingAPI.actions';

export const lendingAPISagaWorkers = [
    forkLatestAPI(apiActions.API_GET_SITE_CONTEXT, lendingApi.fetchSiteContext),
    forkLatestAPI(
        apiActions.API_GET_CUSTOMER_STATE,
        lendingApi.fetchLendingState
    ),
    forkLatestAPI(
        apiActions.API_PUT_CUSTOMER_STATE,
        lendingApi.fetchSaveLendingState
    ),
    forkLatestAPI(
        apiActions.API_GET_DOCUMENT_TO_SIGN,
        lendingApi.fetchSignDocumentByURL
    ),
    forkLatestAPI(
        apiActions.API_GET_SIGNED_DOCUMENT,
        lendingApi.fetchSignedDocumentByURL
    ),
    forkLatestAPI(
        apiActions.API_PUT_AGREE_CUSTOMER_DOCUMENT,
        lendingApi.fetchAgreeSignDocument
    ),
    forkLatestAPI(
        apiActions.API_GET_PAYMENT_METHOD,
        lendingApi.fetchPaymentMethod
    ),
    forkLatestAPI(
        apiActions.API_GET_URL_FILE_TO_DOWNLOAD,
        lendingApi.downloadFile
    ),
    forkLatestAPI(
        apiActions.API_PUT_PAYMENT_METHOD,
        lendingApi.fetchUpdatePaymentMethod
    ),
    forkLatestAPI(
        apiActions.API_POST_PAYMENT_METHOD,
        lendingApi.fetchSavePaymentMethod
    ),
    forkLatestAPI(
        apiActions.API_POST_THREATMETRIX,
        lendingApi.fetchSaveThreatmetrix
    ),
    forkLatestAPI(
        apiActions.API_PUT_THREATMETRIX,
        lendingApi.fetchUpdateThreatmetrix
    ),
    forkLatestAPI(
        apiActions.API_DELETE_PAYMENT_METHOD,
        lendingApi.fetchDeletePaymentMethod
    ),
    forkLatestAPI(
        apiActions.API_GET_ADDRESS_LOOKUP,
        lendingApi.fetchAddressLookup
    ),
    forkLatestAPI(
        apiActions.API_GET_FUNDING_REQUIREMENT,
        lendingApi.fetchFundingRequirement
    ),
    forkLatestAPI(
        apiActions.API_GET_PRODUCT_OFFERS,
        lendingApi.fetchProductOffers
    ),
    forkLatestAPI(apiActions.API_GET_OFFERS, lendingApi.fetchOffers),
    forkLatestAPI(
        apiActions.API_GET_FORMAL_OFFERS,
        lendingApi.fetchFormalOffers
    ),
    forkLatestAPI(
        apiActions.API_POST_FORMAL_OFFERS,
        lendingApi.fetchFormaliseOffers
    ),
    forkLatestAPI(
        apiActions.API_POST_DECLINE_APPLICATION,
        lendingApi.fetchDeclineApplication
    ),
    forkLatestAPI(apiActions.API_GET_APPLICATION, lendingApi.fetchApplication),
    forkLatestAPI(
        apiActions.API_PUT_APPLICATION,
        lendingApi.fetchSaveApplication
    ),
    forkLatestAPI(apiActions.API_GET_ACCOUNTS, lendingApi.fetchAccounts),
    forkLatestAPI(
        apiActions.API_GET_COMPANY_LOOKUP,
        lendingApi.fetchCompanyLookup
    ),
    forkLatestAPI(
        apiActions.API_GET_LOAN_DOCUMENTS,
        lendingApi.fetchRequiredLoanDocuments
    ),
    forkLatestAPI(
        apiActions.API_POST_FUNDING_REQUEST,
        lendingApi.fetchFundingRequest
    ),
    forkLatestAPI(
        apiActions.API_POST_ONFIDO_SMS,
        lendingApi.fetchSaveOnfidoSMS
    ),
    forkLatestAPI(
        apiActions.API_POST_ID_CHECK_SMS,
        lendingApi.fetchSaveIDCheck
    ),
    forkLatestAPI(API_GET_IWOCAPAY_PAY_LINKS, lendingApi.fetchAllPayLinks),
    forkLatestAPI(
        API_GET_IWOCAPAY_CAPTURED_PAYMENTS,
        lendingApi.fetchAllCapturedPayments
    ),
    fork(lendingUpdateVersionOnPutWorker),
    forkLatestAPI(
        apiActions.API_GET_RBL_ESTIMATED_SCHEDULE,
        lendingApi.getRBLEstimatedSchedule
    ),
    forkLatestAPI(
        apiActions.API_POST_FUND_PRODUCT_OFFER_REQUEST,
        lendingApi.postFundProductOfferRequest
    ),
    forkLatestAPI(
        apiActions.API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE,
        lendingApi.fetchDrawDownRepaymentSchedule
    ),
    forkLatestAPI(
        apiActions.API_GET_EARLY_REPAYMENT_SIMULATION,
        lendingApi.fetchEarlyRepaymentSimulation
    ),
    forkLatestAPI(
        apiActions.API_PATCH_APPLICATION_ACCOUNT_FILE,
        fetchPatchApplicationsAccountFileFeedback
    )
];

function* lendingUpdateVersionOnPutWorker() {
    yield takeLatest(apiActions.API_SAVE_CUSTOMER_STATE, function* () {
        const { customer_state } = yield selectAPI();
        const isCustomerStateValid = validateCustomerState(customer_state);

        if (!isCustomerStateValid) {
            return yield put({
                type: OPEN_ERROR_MODAL,
                id: 'FallbackErrorModal'
            });
        }

        const nextAction = yield putAndWaitAPI({
            type: apiActions.API_PUT_CUSTOMER_STATE,
            body: JSON.stringify({ data: customer_state })
        });
        switch (nextAction.type) {
            case apiActions.API_PUT_CUSTOMER_STATE_SUCCESS:
                yield put({ type: apiActions.API_GET_CUSTOMER_STATE });
                yield take(apiActions.API_GET_CUSTOMER_STATE_SUCCESS);
                yield put({ type: apiActions.API_SAVE_CUSTOMER_STATE_SUCCESS });
                break;

            case apiActions.API_PUT_CUSTOMER_STATE_FAIL:
                yield put({ type: apiActions.API_SAVE_CUSTOMER_STATE_FAIL });

                if (isTimeoutSessionResponse(nextAction)) {
                    yield put({
                        type: OPEN_ERROR_MODAL,
                        id: 'TimeoutSessionErrorModal'
                    });
                } else {
                    yield put({
                        type: OPEN_ERROR_MODAL,
                        id: 'FallbackErrorModal'
                    });
                }
                break;
        }
    });
}
